const { type } = require('constants/Referral');

const initialState = {
   list: {
      loading: false,
      error: '',
      data: [],
      page: 1,
      totalPage: null,
      totalData: 0,
   },
   detail: {
      loading: false,
      error: '',
      data: null,
   },
   members: {
      loading: false,
      error: '',
      data: [],
   },
};

const referralReducer = (state = initialState, action) => {
   switch (action.type) {
      case type.GET_LIST_REFERRAL_LOADING:
         return {
            ...state,
            list: {
               ...state.list,
               loading: true,
            },
         };
      case type.GET_LIST_REFERRAL_SUCCESS:
         return {
            ...state,
            list: {
               ...state.list,
               loading: false,
               error: '',
               data: action.data,
               totalPage: parseInt(action.totalPage),
               totalData: parseInt(action.totalData),
               page: action.page || state.list.page,
            },
         };
      case type.GET_LIST_REFERRAL_FAILED:
         return {
            ...state,
            list: {
               ...state.list,
               loading: false,
               error: action.message,
            },
         };
      case type.GET_DETAIL_REFERRAL_LOADING:
         return {
            ...state,
            detail: {
               ...state.detail,
               loading: true,
               data: null,
            },
         };
      case type.GET_DETAIL_REFERRAL_SUCCESS:
         return {
            ...state,
            detail: {
               ...state.detail,
               loading: false,
               error: '',
               data: action.data,
            },
         };
      case type.GET_DETAIL_REFERRAL_FAILED:
         return {
            ...state,
            detail: {
               ...state.detail,
               loading: false,
               error: action.message,
            },
         };
      case type.GET_REFERRAL_MEMBERS_LOADING:
         return {
            ...state,
            members: {
               ...state.members,
               loading: true,
               data: [],
            },
         };
      case type.GET_REFERRAL_MEMBERS_SUCCESS:
         return {
            ...state,
            members: {
               ...state.members,
               loading: false,
               error: '',
               data: action.data || [],
            },
         };
      case type.GET_REFERRAL_MEMBERS_FAILED:
         return {
            ...state,
            members: {
               ...state.members,
               loading: false,
               error: action.message,
            },
         };
      default:
         return state;
   }
};

export default referralReducer;
